import React, {useState, useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import DashboardHeader from '../dashboardHeader'
import DashBoardContainer from '../../../components/containers/dashboardContainer'
import HorizontalTextinput from '../../../components/horizontalTextinput'
import {

    updateFirmApplication,
    fetchFirmApplicationStatus as fetchFirmApplication,
    validateMembershipNumber

} from '../../../actions'
import {SUBMIT_FIRM_APPLICATION_ID} from '../../../store/loaders'
import { v4 as uuidv4 } from 'uuid'
import { normalizeInput } from '../../../utility/utils'




const CompanyShareHoldersDetails = (props)=>{

    const history = useHistory()
    const dispatch = useDispatch()


    const apiResponse = useSelector((state=>{
        const {
            firmApplication, 
            loader,
            firmApplicationSubmitted,
            hasUpdatedFirm,
            validateMembership
        } = state
        const {application} = firmApplication
        const {isLoading} = loader[SUBMIT_FIRM_APPLICATION_ID] || {isLoading: false}
        const {response} = firmApplicationSubmitted
        const {updateId} = hasUpdatedFirm
        const {data} = validateMembership

        return{
            application,
            isLoading,
            response,
            updateId,
            data
        }
    }))





    const [fullNames,
        setFullNames] = useState('')
    const [qualification, 
        setQualification] = useState('')
    const [phoneNumber,
        setPhoneNumber] = useState('')
    const [nationalId, 
        setNationalId] = useState('')
    const [eirNumber, 
        setEirNumber] = useState('')
    const [newStakeHoldersArr,
        setNewStakeHoldersArr] = useState([])
    const [applicationDetails, setApplicationDetails] = useState({})

    const [ierNumberError, setIerNumberError] = useState(false)
    const [ierNumberHelperText, setIerNumberHelperText] = useState('')
    

    const [idNumberError, setIdNumberError] = useState(false)
    const [idNumberHelperText, setIdNumberHelperText] = useState('')


    const applicationId = apiResponse.application?.applicationId || apiResponse.application?.id
    var actionLoader = apiResponse.isLoading
    const appId = props.location.state && props.location.state.application?.id



    const [requestId, setRequestId] = useState('')
    const [cacheId, setCacheId] = useState('')



    useEffect(()=>{
        dispatch(fetchFirmApplication(appId))
        setFullNames('')
        setPhoneNumber('')
        setIerNumberError(false)
        setIerNumberHelperText("")
    },[])


    useEffect(()=>{
        if(apiResponse.response?.status === 'success'){
            dispatch(fetchFirmApplication(appId))
        }
    },[apiResponse.response])

    useEffect(()=>{
        if(apiResponse.updateId === requestId && apiResponse.response?.status === 'success'){
            history.push({
                pathname: '/dashboard',
                state: applicationDetails
            })
        }
    },[apiResponse.updateId])


    useEffect(()=>{
        if(apiResponse.application?.id){
            setApplicationDetails({
                ...apiResponse.application
            })
        }
        if(apiResponse.application?.stakeholders?.length > 0) {
            setNewStakeHoldersArr(apiResponse.application.stakeholders)
        }

    },[apiResponse.application])

    useEffect(()=>{
        if(apiResponse.data?.status === 200 && apiResponse.data?.id === cacheId){
            setIerNumberError(false)
            setIerNumberHelperText("")
            setFullNames(apiResponse.data?.data?.name)
            setPhoneNumber(apiResponse.data?.data?.contactTelephoneNumber)
            setNationalId(apiResponse.data?.data?.IdentificationNumber)
        }
        if(apiResponse.data?.status === 204){
            setIerNumberError(true)
            setIerNumberHelperText("No content found")
            setFullNames('')
            setPhoneNumber('')
        }
    },[apiResponse.data])

    const handleNewStakeHoldersArr = ()=>{
        if(fullNames === '' || phoneNumber === '' || nationalId === ''){
            return 
        }
        setNewStakeHoldersArr([...newStakeHoldersArr, {
            fullNames,
            qualification,
            phoneNumber,
            nationalId,
            eirNumber,
        }])
        setFullNames('')
        setQualification('')
        setPhoneNumber('')
        setNationalId('')
        setEirNumber('')
    }



    const debounce = (cb, delay = 1000)=>{
        let timeout 
        return (...args) => {
            timeout = ''
            timeout = setTimeout(() =>{
                cb(...args)
            }, delay)
        }
    }

    const updateDebounce = debounce((text)=>{
        var id = uuidv4()
        setCacheId(id)
        dispatch(validateMembershipNumber({value: text.target.value, id}))
    },1000)



    const handleProfessionalIerNumber = (text)=>{
        var id = uuidv4()
        setCacheId(id)
        setIerNumberError(false)
        setIerNumberHelperText("")
        setEirNumber(text.target.value)
        dispatch(validateMembershipNumber({value: text.target.value, id}))
    }

    const handleDeleteItem = (id)=>{
        var deletedItem 
        deletedItem = newStakeHoldersArr.filter(function(el,index){
            return index !== id
        })
        setNewStakeHoldersArr(deletedItem)
    }   

    var addNewArr 
    if(newStakeHoldersArr.length > 0 ){
        addNewArr = newStakeHoldersArr.map((value, id)=>{
            return(
                <div className="dashboarder-grey-contanier mt-4 mb-4">
                    <div style={{width:'20%'}}>
                        <HorizontalTextinput 
                            title="Full names"
                            value={value.fullNames || value.fullName}
                            disabled = {true}
                            />
                    </div>
                    <div style={{width:'17%'}}>
                        <HorizontalTextinput 
                            title="Phone"
                            value={value.phoneNumber || value.telephoneNumber}
                            disabled = {true}
                            />
                    </div>

                    <div style={{width:'17%'}}>
                        <HorizontalTextinput 
                            title="National ID number"
                            value={value.nationalId || value.nationalIdNumber}
                            disabled = {true}
                            />
                    </div>
                    <div style={{width:'17%'}}>
                        <HorizontalTextinput 
                            title="IER number"
                            value={value.eirNumber || value.ierMemberNumber}
                            disabled = {true}
                            />
                    </div>
                    <div className="addition-container-circle">
                        <div className="addition-red-ctn mt-4" onClick={()=>handleDeleteItem(id)}>
                            <span>-</span>
                        </div>
                    </div>
                </div>
            )
        })
    }

    const handleSaveForLater = ()=>{

        const reqId = uuidv4()
        setRequestId(reqId)

        var stakeHoldersArr = []
        if(true){
            stakeHoldersArr.push({
                fullName: fullNames,
                ierMemberNumber: eirNumber,
                nationalIdNumber: nationalId,
                qualification: qualification,
                telephoneNumber: phoneNumber

            })
        }
        if(newStakeHoldersArr.length > 0 ){
            newStakeHoldersArr.map(value=>{
                stakeHoldersArr.push({
                    fullName: value.fullNames || value.fullName,
                    ierMemberNumber: value.eirNumber || value.ierMemberNumber,
                    nationalIdNumber: value.nationalId || value.nationalIdNumber,
                    qualification: value.qualification,
                    telephoneNumber: value.phoneNumber || value.telephoneNumber
                })
            })
        }
        if(applicationId){
            dispatch(updateFirmApplication({
                data: {
                    ...applicationDetails,
                    stakeholders:stakeHoldersArr
                },
                id: applicationId,
                reqId: reqId
            }))
            setFullNames('')
            setPhoneNumber('')
            setIerNumberError(false)
            setIerNumberHelperText("")
        }
    }

    const handleSubmit = ()=>{
        history.push({
            pathname: '/applicant/company/projects',
            state: {
                application:applicationDetails
            }
        })
        handleSaveForLater()
    }

    const handleCancel = ()=>{
        history.push(
            {
                pathname: '/applicant/company/contacts',
                state:{
                    application: applicationDetails
                }
            }
        )
    }

    return (
        <div>
            <DashboardHeader
                activeStep={4}
                application={applicationDetails}/>
            <DashBoardContainer
                handleSubmit={handleSubmit}
                handleCancel={handleCancel}
                middleTitle="Save for Later"
                title="Next"
                handleSaveForLater={handleSaveForLater}
                disabled={actionLoader}
                loader={actionLoader}>
                  <div className="d-flex w-100" style={{
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <span className="dashboard-green-text-header mb-4">
                    Company Directors or Shareholders details
                    </span>
                </div>
                <div className="dashboarder-grey-contanier">
                    <div style={{width:'20%'}}>
                        <HorizontalTextinput 
                            title="IER number (if member)"
                            handleChange={(text)=>{
                                updateDebounce(text)
                                setIerNumberError(false)
                                setIerNumberHelperText("")
                                setEirNumber(text.target.value)
                            }}
                            value={eirNumber}
                            type="text"
                            error={ierNumberError}
                            helperText={ierNumberHelperText}
                            placeholder="Ex: B001/GC/IER/2021"
                            required={true}
                            />
                    </div>
                    <div style={{width:'17%'}}>
                            <HorizontalTextinput 
                                title="Full names"
                                handleChange={(text)=>setFullNames(text.target.value)}
                                value={fullNames}
                                type="text"
                                disabled = {true}
                                // required={true}

                            />
                        </div>

                        <div style={{width:'17%'}}>
                            <HorizontalTextinput 
                                title="Phone"
                                handleChange={(text)=>setPhoneNumber(normalizeInput(text.target.value,phoneNumber))}
                                value={phoneNumber}
                                type="text"
                                disabled = {true}
                                // required={true}
                            />
                        </div>

                        <div style={{width:'17%'}}>
                            <HorizontalTextinput 
                                title="ID Number (NID/Passport)"
                                handleChange={(text)=>setNationalId(text.target.value)}
                                value={nationalId}
                                error={idNumberError}
                                helperText={idNumberHelperText}
                                // required={true}
                                disabled={true}
                                />
                        </div>
                    <div className="addition-container-circle">
                        <div className="addition-blue-ctn mt-4" onClick={handleNewStakeHoldersArr}>
                            <span>+</span>
                        </div>
                    </div>
                </div>
              {addNewArr}
            </DashBoardContainer>
        </div>
    )
}

export default CompanyShareHoldersDetails